/*###########################################################################
// Reveal
//#########################################################################*/

import { throttle } from '../utilities/_throttleDebounce'
import { inViewport } from '../utilities/_inViewport'

const reveal = {
  config: {
    revealEl: '.reveal'
  },

  elements: {
    revealEls: null
  },

  init(pageChange) {
    const self = this

    self.elements.revealEls = document.querySelectorAll(self.config.revealEl)

    if (self.elements.revealEls !== null) {
      for (let i = 0; i < self.elements.revealEls.length; i++) {
        const revealEl = self.elements.revealEls[i]
        self.handleRevealEl(revealEl, pageChange)
      }
    }
  },

  handleRevealEl(revealEl, pageChange) {
		const triggerEl = revealEl.closest('[reveal-group]') ?? revealEl
		const inViewportOnInit = inViewport(triggerEl, window.innerHeight/20)
		const delay = revealEl.getAttribute('delay') || 0

    // Check if in viewport already (scroll saved)
    //
    if (inViewport(triggerEl, window.innerHeight/20) && !revealEl.classList.contains('revealed')) {
			if (pageChange) {
				setTimeout(function() {
					revealEl.classList.add('revealed')
				}, 400 + parseInt(delay))
			} else {
				if (delay) {
					setTimeout(function() {
						revealEl.classList.add('revealed')
					}, parseInt(delay))
				} else {
					revealEl.classList.add('revealed')
				}
			}
    }

    window.addEventListener('scroll', throttle(function() {
      if (!inViewportOnInit && inViewport(triggerEl, window.innerHeight/20) && !revealEl.classList.contains('revealed')) {
        if (delay) {
					setTimeout(function() {
						revealEl.classList.add('revealed')
					}, parseInt(delay))
				} else {
					revealEl.classList.add('revealed')
				}
      }
    }, 100))
  }
}

initComponent((pageChange) => {
	reveal.init(pageChange)
})
